import {GetterTree} from 'vuex';
import {RootState, UserState} from '@/types';

const getters: GetterTree<UserState, RootState> = {
  invitationKeyErrorMessage: (state) => state.invitationKeyErrorMessage,
  processingInvitationKey: (state) => state.processingInvitationKey,
  isLoading: (state) => state.isLoading,
  uuid: (state) => state.uuid,
  user: (state) => state.user,
  subscriptions: (state) => state.subscriptions,
};

export default getters;



// WEBPACK FOOTER //
// ./src/store/modules/user/getters.ts